import RaceSelector, { RaceSelectorData } from "@/app/ui/Common/RaceSelector";
import { theme, paddingNum, getSearchParams, generateAdobeDataRaceNo, adobeData, setRacesDetailLoading, setRouting } from "@/app/utils/Common";
import { dateFormat, formattedDate, toDate } from "@/app/utils/DayJS";
import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import "@/app/style/results.scss";
import ReplayIcon from "@/app/ui/Common/SvgComponent/ReplayIcon";
import DividendTable from "./DividendTable";
import { Box, useMediaQuery } from "@mui/material";
import ResultTable from "./ResultTable";
import VideoPlayer from "@/app/ui/Common/VideoPlayer";
import { getRaceResultsList, getRaceRepaly } from "@/app/utils/request/requestList";
import { useMyContext } from "@/app/utils/MyContext";
import { LANGCODE_EN, LANGTYPE_EN, LangCode, useLanguage } from "@/app/utils/LanguageContext";
import { generateVideoSource, generateVideoUrl } from "@/app/utils/Video";
import { VideoSource } from "@/app/utils/class/common/video";
import { VideoReplay } from "@/app/utils/class/qids/videoReplay";
import { RaceNo } from "@/app/utils/class/common/base";
import { textSize, text_size } from "@/app/utils/MixinSize";
import NoInformation from "@/app/ui/Common/NoInformation";
import { VideoWAData } from "@/app/ui/Common/VideoPlayer/player";
import { oddType, singlePools } from "@/app/utils/constant/odd";
import Loading from '@/app/ui/Common/Loading';
import {raceResultStatus} from "@/app/utils/constant/statusSet";
import { useLoading } from "@/app/utils/LoadingContext";
  
const Header = styled.div`
    padding: 10px 12px 10px 12px;
    width: 100%;
    height: 40px;
    border-radius: 4px 4px 0px 0px;
    background: #132b68;
    display: flex;
    align-items: center;
    ${text_size(15)}
    font-weight: 400;
    line-height: 16px;
    color: white;
`;

const StyledRemarkDiv = styled('span')(() => ({
    'p': {
        ...textSize(11),
        fontWeight: 500,
        lineHeight: "16px",
        paddingTop: "10px",
        color: "#333333"
    }
}));

const MResultWrapper = styled('div')(() => ({
    padding: "12px",
    backgroundColor: "#F6F6F6",
    borderRadius: "0px 0px 4px 4px",
    boxShadow: "0px 2px 10px 0px #0000001A"
}));

const AllResultWrapper = styled('div')(() => ({
    backgroundColor: "white",
    boxShadow: "0px 2px 10px 0px #0000001A",
    padding: "12px",
    "& >div+div": {
        marginTop: "24px"
    },
}));

const CardHeader = styled.div`
    padding: 10px 12px 10px 12px;
    width: 100%;
    height: 40px;
    border-radius: 4px 4px 0px 0px;
    background: var(--extraPalette-primary-darkGrey);
    display: flex;
    align-items: center;
    p {
        ${text_size(15)}
        font-weight: 400;
        line-height: 16px;
        color: white;
    }
`;

const CardTitle = styled.div`
    height: 44px;
    padding: 12px 0 12px 12px;
    position: relative;
    
    p {
        ${text_size(13)}
        font-weight: 500;
        line-height: 17px;
        width: 88%;      
        display: inline-flex;
    }

    div {
        width:12%;
        display: inline-flex;
    }
`

const ResultPageWrapper = styled.div`
    >#dividendTableWrapper {
        margin: 12px 0;
    }
`;

const ResultsCardWrapper = styled.div`
    .cardTitle:before, .cardTitle:after {
        content: " ";
        height: 100%;
        position: absolute;
        top: 0;
        width: 10px;
    }
    .cardTitle:before {
        box-shadow: -10px 2px 10px -10px inset #0000001A;
        left: -10px;
    }
    .cardTitle:after {
        box-shadow: 10px 2px 10px -10px inset #0000001A;
        right: -10px;
    }
`;

const DivMessage = styled.div`
    ${text_size(13)}
    font-weight: 500;
    padding: 12px;
    line-height: 17px;
    background-color: white;
`;
const DivNotOfferMessage = styled.div`
    ${text_size(13)}
    font-weight: 500;
    padding: 12px;
    line-height: 17px;
    background-color: white;
`;

const DivAllResult = styled.div`
    padding-left: 12px;
    padding-top: 12px;
    width: calc(100% - 324px);

    @media only screen and (min-width:1808px){
        width: calc(100% - 567px);
    }
    
`;

const DivAllDividend = styled.div`
    padding-left: 12px;
    padding-top: 12px;
    width: 324px;

    @media only screen and (min-width:1808px){
        width: 567px;
    }
`;


interface propType {
  setRacesDetailLoading: (loading: boolean) => void;
    type?: string;
    dataSource?: string;
    isLoadingRacesDetail? :boolean;
}

interface RaceDesc {
    raceName: string;
    going: string;
    time: string;
    course: string;
    winningTime: string;
    fullResultReady: boolean;
}

const videoExpiredScreen = (langCode: LangCode, assetPrefix?: string)=>{
    const imgSrc = `${assetPrefix}/${langCode === LANGCODE_EN ? "video_n_available_480x390_e.jpg" : "video_n_available_480x390_c.jpg"}`
    return (
        <Box className="screenContainer">
            <img className="responsiveImg" src={imgSrc} />
        </Box>
    )
}

const Results: React.FC<propType> = (props: propType) => {
    const { isLoading, triggerLoading, completeLoading } = useLoading();
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
    const { state: lang } = useLanguage();
    const { t } = lang;
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const [selectedVenueCode, setSelectedVenueCode] = useState<string>(myContextState?.selectedMeetingVenueCode);
    const [selectedRaceNo, setSelectedRaceNo] = useState<number>(myContextState?.selectedRaceNo.valueOf());
    const [raceNosData, setRaceNosData] = useState([] as number[]);
    const [pmPoolsData, setpmPoolsData] = useState([]);
    const [raceData, setRaceData] = useState([]);
    const [raceMeetingProfileData, setRaceMeetingProfileData] = useState([]);
    const [replaySources, setReplaySources] = useState([] as VideoSource[]);
    const [resultVideos, setResultVideos] = useState([] as VideoReplay[]);
    const [isShowResult, setIsShowResult] = React.useState(true);
    const [isShowDividend, setIsShowDividend] = React.useState(true);
    const [displayMessage, setDisplayMessage] = React.useState('');
    const [hasResultsData, setHasResultsData] = React.useState(true);
    const [isDisplayReplay, setIsDisplayReplay] = useState(false);
    const [raceDesc, setRaceDesc] = useState<any>(null);
    const [meetingStatus, setMeetingStatus] = React.useState('');
    const { b_cid } = getSearchParams(new URLSearchParams(window.location.search));
    const [raceSelectorData, setRaceSelectorData] = useState<RaceSelectorData|undefined>();
    // video
    const [isShowReplay, setIsShowReplay] = useState(false);
    const [WAData, setWAData] = useState<VideoWAData|undefined>(undefined);
    const [overridedContentSlot, setOverridedContentSlot] = useState<React.ReactNode|undefined>(undefined);
    const isLoadingPage = globalConfig.OTHERS.ENABLE_LOADING_CONTEXT ? isLoading('page') : props.isLoadingRacesDetail;

    // const selectedRaceNo = myContextState.useRouter ? myContextState.selectedRaceNo?.valueOf() : selectedRaceNo;

    useEffect(()=>{
        if (myContextState.dataSource !== "qids") return; 
        // For non historical result, will handle in getRaceResultsList()
        setRaceSelectorData(myContextState.raceSelectorData);
    }, [myContextState.raceSelectorData]);

    useEffect(()=>{
        if (myContextState.dataSource !== "qids" || !myContextState.selectedMeetingVenueCode) return; 
        // For non historical result, will handle in getRaceResultsList()
        setRaceNosData(raceSelectorData?.[myContextState.selectedMeetingVenueCode]?.races || []);
    }, [raceSelectorData, myContextState.selectedMeetingVenueCode]);

    const handleSelectRace = (raceNo: number, venueCode?: string) => {
        if (raceNo !== myContextState.selectedRaceNo.valueOf() || venueCode !== myContextState.selectedMeetingVenueCode) {
            setRacesDetailLoading(props.setRacesDetailLoading, myContextState.menuTab.toString(), true, true);
            if (myContextState.dataSource === 'qids'){
                triggerLoading('page');
                setRouting(undefined, {'Racecourse': venueCode, 'RaceNo': new RaceNo(raceNo).toParams(), 'b_cid': ''});
            } else {
                triggerLoading('race', myContextState.menuTab.toString());
            }
            if (venueCode) setSelectedVenueCode(venueCode);
            setSelectedRaceNo(raceNo);
            myContextDispatch({
                type: "update",
                value: { selectedRaceNo: new RaceNo(raceNo), ...(venueCode && { selectedMeetingVenueCode: venueCode?.toUpperCase()}) },
            });
        }
    }

    const openVideoPlayer = (raceNo: number, resultVideo?: VideoReplay) => {
        if (!resultVideo) return;
        if (resultVideo?.isExpired()){
            setOverridedContentSlot(videoExpiredScreen(lang.langCode, myContextState.assetPrefix));
        } else {
            setWAData({
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode , raceNo),
            contentTitle: t("race_replay_title"),
            });
            const url = generateVideoUrl(resultVideo?.getVideoMiddlePath());
            setReplaySources(generateVideoSource(url.sd, url.hd));
        }
        setIsShowReplay(true);
    }

    const handleClose = () => {
        setIsShowReplay(false);
        setReplaySources([]);
        setWAData(undefined);
        setOverridedContentSlot(undefined);
    }

    const RaceDescription = (races: any, raceNo: number): RaceDesc => {
        const raceObj = races.filter((x: any) => x.no == raceNo)[0];
        if (raceObj == null)
            return {
                raceName: '',
                going: '',
                time: '',
                course: '',
                winningTime: '',
                fullResultReady: false,
            };
        let desc = [];

        const language = lang.langType === LANGTYPE_EN ? "en" : "ch";

        desc = [];
        if (raceObj.raceTrack['description_' + language] != null && raceObj.raceTrack['description_' + language] != '') {
            desc.push(raceObj.raceTrack['description_' + language]);
        }
        if (raceObj.raceCourse[`description_${language}`] != null && raceObj.raceCourse[`description_${language}`] != '') {
            desc.push(raceObj.raceCourse[`description_${language}`])
        }
        if (raceObj['country_' + language] != null && raceObj['country_' + language] != '')
            desc.push(raceObj['country_' + language]);
        const course = desc.join(', ');


        desc = [];
        desc.push(raceObj['raceName_' + language]);
        if (raceObj['raceClass_' + language] != null && raceObj['raceClass_' + language] != '')
            desc.push(raceObj['raceClass_' + language]);
        let raceName = desc.join(', ');
        if (raceObj.distance != null && raceObj.distance != '')
            raceName += ' - ' + raceObj.distance + (lang.langType === LANGTYPE_EN ? "M" : "米");


        let going = '-';
        if (raceObj['go_' + language] != null && raceObj['go_' + language] != '')
            going = raceObj['go_' + language];

        const winTime = raceObj.raceResults?.[0]?.raceTime || '';

        const resultStatus = raceObj.raceResults?.[0]?.status || '';

        return {
            raceName: raceName,
            going: going,
            time: formattedDate(toDate(raceObj?.postTime, dateFormat.qids.datetime), dateFormat.display.fulldatetime),
            course: course,
            winningTime: winTime,
            fullResultReady: resultStatus.toUpperCase() === raceResultStatus.WCFULLMARGIN
        }
    }

    useEffect(() => {
        if (myContextState.isLoadingRaces) return
        console.log('------myContextState?.selectedRaceNo---', myContextState?.selectedRaceNo, myContextState?.selectedMeetingVenueCode)
        const venueCode = myContextState?.selectedMeetingVenueCode;
        if (venueCode === '') {
            setRacesDetailLoading(props.setRacesDetailLoading)
            completeLoading('page');
            return
        }

        setSelectedVenueCode(myContextState?.selectedMeetingVenueCode);
        const currRaceNo = myContextState.selectedRaceNo.valueOf();
        setSelectedRaceNo(currRaceNo);
        const controller = new AbortController();
        const signal = controller.signal;
        const timeout = myContextState?.dataSource === 'qids' ? 10000 : undefined; // set longer timeout for old data
        
        const basicProm = new Promise((resolve, reject) => {
        getRaceResultsList(myContextState?.selectedMeetingDate, venueCode, signal, timeout)
            .then((res: any) => {
                const races = res.raceMeetingProfile[0]?.races ?? [];
                if (myContextState.dataSource !== "qids") {
                    const raceNos = races?.map((r: any) => r.no) || [];
                    setRaceSelectorData({[venueCode]: {races: raceNos}});
                    setRaceNosData(raceNos);
                }
                if (races.length === 0 || 
                    (myContextState.selectedRaceNo.valueOf() !== -1 &&
                    !races.find((r: any)=> r.no === myContextState.selectedRaceNo.valueOf()))
                ) {
                    setHasResultsData(false);
                    return;
                } else {                    
                    setHasResultsData(true);
                }
                setMeetingStatus(res.raceMeetingProfile[0]?.status);
                const pmpools = res.raceMeetingProfile[0]?.pmPools ?? [];
                setpmPoolsData(pmpools);
                setRaceData(races);
                setRaceMeetingProfileData(res.raceMeetingProfile[0]);
                //setResultVideos(res.videoReplay?.filter((v: IVideoReplay) => v.language === lang.langType).map((v: IVideoReplay) => new VideoReplay(v)));
                setRaceDesc(RaceDescription(races, currRaceNo));

                const isBettingOffer = isBettingOfferF(pmpools, currRaceNo);
                const isVoidRace = isVoidedRaceF(res.raceMeetingProfile[0], currRaceNo);
                const isAbandonRace = isAbandonedRaceF(races, currRaceNo);

                const isPMResultReady = hasPMResultF(races, pmpools, currRaceNo);
                const isResultReady = hasRaceResultF(races, pmpools, currRaceNo);

                const isDivReady = pmpools.filter((x: any) => x.leg.races[x.leg.races.length - 1] == currRaceNo
                    && (x.status == "PAYOUT" || x.status.indexOf("REFUND") >= 0)).length > 0;

                //console.log("result_not_offered",!isBettingOffer,isPMResultReady,!isVoidRace,!isAbandonRace);
                const getMessage = () => {
                    if (!isBettingOffer && isPMResultReady && !isVoidRace && !isAbandonRace) return 'result_not_offered';
                    if (!isBettingOffer && (isVoidRace || isAbandonRace)) return isAbandonRace ? 'result_not_offered_abandoned' : 'result_not_offered_void';
                    if ((isVoidRace || isAbandonRace) && !isPMResultReady && isBettingOffer) return isAbandonRace ? 'result_abandoned' : 'result_void';
                    if (!isResultReady) return 'result_not_ready'; //&& !isDivReady
                    return '';
                }
                const msg = getMessage();
                setDisplayMessage(msg);

                //race replay will not be available: Non-finished race, Abandoned race
                //race replay will still be available: Race not offered
                const displayRaceReplay = () => {
                    return msg === '' || (msg === 'result_not_offered' && isResultReady);
                }
                setIsDisplayReplay(displayRaceReplay());

                //Result will not be shown: Non-finished race, Abandoned race
                //result table(single) will still be shown: Race not offered
                setIsShowResult(displayRaceReplay());

                //Dividend will not be shown: Non-finished race, Race not offered
                //Dividend will still be shown: Abandoned race
                const displayDividend = () => {
                    return msg === '' || msg === 'result_abandoned' || isDivReady;
                }
                setIsShowDividend(displayDividend());

                if (myContextState.dataSource === "qids") {
                    // adobeAnalysis - page
                    adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "pageview", {
                        pageId: "racing/simulcast",
                        raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo.valueOf()),
                        internalAd: b_cid
                    });
                }
            })
            .catch((e: any) => {
                console.log(e);
            }).finally(() => {
                setRacesDetailLoading(props.setRacesDetailLoading)
                completeLoading('page');
            });
        });

        
        const videoProm = new Promise((resolve, reject) => {
        getRaceRepaly(lang.langCode, myContextState.season, formattedDate(myContextState.selectedMeetingDate, "YYYYMMDD"), signal, timeout)//23_24 20231005
            .then((res: any) => { 
                let curRaceReplay = [] as VideoReplay[];
                res?.item?.replayList.forEach((item: any) => { 
                    const curList = item?.raceNoList?.filter((x: any) => x.raceIndicator.targetItem?.option_Value?.value.toUpperCase() == venueCode.toUpperCase()) 
                    if(curList && curList.length > 0){
                        const list = curList.map((r: any, i: number) => {
                            return new VideoReplay({
                                hkRaceDate: formattedDate(myContextState.selectedMeetingDate, "YYYY-MM-DD"),
                                raceNo: paddingNum(r?.raceNo?.value).toString(),
                                overseasRaceIndicator: r?.raceIndicator.targetItem?.option_Value?.value,
                                videoPresentOrNot: r?.videoPresentorNot.targetItem?.option_Value?.value,
                                //raceStatus: r?.raceStatus.targetItem?.option_Value?.value,
                                isVideoReplayOn: r?.raceStatus.targetItem?.option_Value?.value == "N",
                                language: lang.langType
                            })
                        })
                        curRaceReplay = list; 
                        return;
                    }  
                });
                setResultVideos(curRaceReplay)
                console.log("getRaceRepaly", res?.item?.replayList, curRaceReplay, myContextState)
                 
                //setResultVideos(res.videoReplay?.filter((v: IVideoReplay) => v.language === lang.langType).map((v: IVideoReplay) => new VideoReplay(v)));
            }).catch((e: any) => {
                console.log(e);
            }).finally(() => {
                setRacesDetailLoading(props.setRacesDetailLoading)
                completeLoading('page');
            });
        });
        
      Promise.all([basicProm, videoProm])
      .finally(() => {
        if (signal.aborted) return;
            setRacesDetailLoading(props?.setRacesDetailLoading)
            completeLoading('page');
      })
    }, [myContextState.isLoadingRaces, myContextState.selectedMeetingVenueCode, myContextState?.selectedRaceNo]);
       
    const isVoidedRaceF = (raceMeetingProfile: any, raceNo: number) => {
        let pools = singlePools;
        let pmPoolsStatus = raceMeetingProfile?.pmPools?.filter((x: any) => x.leg.races[0] === raceNo && pools.includes(x.oddsType)).map((x: any) => x.status);
        let isSinglePoolRefunded = pmPoolsStatus?.length > 0 && pmPoolsStatus.filter((x: any) => x.toUpperCase().indexOf("REFUND") >= 0).length === pmPoolsStatus.length;
        return raceMeetingProfile?.races?.filter((x: any) => x.no === raceNo)[0]?.status === 'VOIDED'
            || raceMeetingProfile?.status == 'ABANDON' || (raceMeetingProfile?.status == 'ABANDON_PARTIAL' && raceMeetingProfile?.races.filter((x: any) => x.no === raceNo)[0]?.status != 'RESULT')
            || isSinglePoolRefunded;
    }

    const isAbandonedRaceF = (races: any, raceNo: number) => {
        return ['ABANDONED'].includes(races?.find((x: any) => x.no === raceNo)?.status)
    }

    const isBettingOfferF = (pmpools: any, raceNo: number) => {
        return pmpools.filter((x: any) => x.leg.races[x.leg.races.length - 1] == raceNo).length > 0
    }
    const hasPMResultF = (races: any, pmPools:any, raceNo: number) => {
        const race = races.filter((x: any) => x.no == raceNo)[0] || {};
        return (race?.judgeSigns?.filter((x: any) => x.value_en == "WEIGHED IN").length > 0
            || !isBettingOfferF(pmPools, raceNo)) && race.status == "RESULT";
    }
    const hasRaceResultF = (races: any, pmPools:any, raceNo: number) => {
        const race = races.filter((x: any) => x.no == raceNo)[0] || {};
        return race.status == "RESULT";
    }
    //console.log("RaceDesc", raceDesc);

    const SimulcastRemark: React.FC = () =>
        <StyledRemarkDiv>
            <p>{t("result_simulcast_remark")}</p>
        </StyledRemarkDiv>
    const SimulcastRemarkNonWagering: React.FC = () =>
        <StyledRemarkDiv>
            <p>{t("result_simulcast_remark_non_wagering")}</p>
        </StyledRemarkDiv>

    const renderResultCard = (raceNo: number) => {
        const resultVideo = getResultVideo(raceNo);

        const isBettingOffer = isBettingOfferF(pmPoolsData, raceNo);
        const isVoidRace = isVoidedRaceF(raceMeetingProfileData, raceNo);
        const isAbandonRace = isAbandonedRaceF(raceData, raceNo);

        const isPMResultReady = hasPMResultF(raceData,pmPoolsData, raceNo);
        const isResultReady = hasRaceResultF(raceData,pmPoolsData, raceNo);

        const isDivReady = pmPoolsData.filter((x: any) => x.leg.races[x.leg.races.length - 1] == raceNo
            && (x.status == "PAYOUT" || x.status.indexOf("REFUND") >= 0)).length > 0;

        const getMessage = () => {
            if (!isBettingOffer && isPMResultReady && !isVoidRace && !isAbandonRace) return 'result_not_offered'; //&& !isPMResultReady
            if (!isBettingOffer && (isVoidRace || isAbandonRace)) return isAbandonRace ? 'result_not_offered_abandoned' : 'result_not_offered_void';
            if ((isVoidRace || isAbandonRace) && !isPMResultReady && isBettingOffer) return isAbandonRace ? 'result_abandoned' : 'result_void';
            if (!isResultReady) return 'result_not_ready'; // && !isDivReady
            return '';
        }
        const msg_all = getMessage();

        //race replay will not be available: Non-finished race, Abandoned race
        //race replay will still be available: Race not offered
        const displayRaceReplay = () => {
            return msg_all === '' || (msg_all === 'result_not_offered' && isResultReady);
        }

        //Dividend will not be shown: Non-finished race, Race not offered
        //Dividend will still be shown: Abandoned race
        const displayDividend = () => {
            return msg_all === '' || msg_all === 'result_abandoned' || isDivReady;
        }

        //All Result will not be shown: Non-finished race, Race not offered, Abandoned race
        //getMessage()==''
        const displayResult = () => {
            return msg_all === ''
        }

        const raceDesc = RaceDescription(raceData, raceNo);
        const fullFieldPlacing = raceDesc?.fullResultReady;

        return (
            <ResultsCardWrapper id={`results_card_${raceNo}_pc`}>
                <CardHeader><p>{t('result_race_no').replace('{0}', raceNo.toString())}</p></CardHeader>
                <CardTitle className="cardTitle">
                    <p>{raceDesc?.raceName}</p>
                    {
                        displayRaceReplay() && resultVideo?.showVideoIcon() &&
                        <div id={`resultRaceReplay_${raceNo}`} className="resultRaceReplay" >
                            <span onClick={() => openVideoPlayer(raceNo, resultVideo)}>{t('result_race_replay')}</span>
                            <ReplayIcon onClick={() => openVideoPlayer(raceNo, resultVideo)} />
                        </div>
                    }
                </CardTitle>
                {
                    msg_all !== '' ? <DivMessage>{t(getMessage())}</DivMessage> : <></>
                }
                <Grid container spacing={1.5}>
                    <DivAllResult>
                        {
                            displayResult() && <ResultTable type="pc" raceNo={raceNo} data={raceData} disableExpansion fullFieldPlacing={fullFieldPlacing} columns={!fullFieldPlacing ? ["place", "horseNo", "horse", "jockey"] : ["place", "horseNo", "horse", "jockey", "trainer", "draw", "hWt"]} />
                        }
                    </DivAllResult>
                    <DivAllDividend>
                        {
                            displayDividend() && <DividendTable type="pc" data={pmPoolsData} raceNo={raceNo} />
                        }
                    </DivAllDividend>
                </Grid>
            </ResultsCardWrapper>
        )
    }


    const renderAllResult = () => {
        const showPool = [oddType.WIN, oddType.PLA];
        let PMUPool = [] as string[];
        let PMUmsg = '';
        console.log("meetingStatus", meetingStatus);
        if (!["START", 'DECLARED', 'DEFINED', 'DRAFT'].includes(meetingStatus.toUpperCase())) {
            const dividendInfo = pmPoolsData.filter((x: any) => x.comingleStatus > 0
                && (x.status == "PAYOUT" || x.status.indexOf("REFUND") >= 0) && showPool.includes(x.oddsType));
            console.log("dividendInfo", dividendInfo, raceData);
            dividendInfo.map((item: any) => {
                if (!PMUPool.includes(item.oddsType)) {
                    PMUPool.push(item.oddsType);
                }

            })
            if (PMUPool.length > 1) {
                PMUmsg = t('result_france_outbound_PMU').replace('{0}', t('result_france_outbound_PMU_oddsType_WP'));
            } else if (PMUPool.length === 1) {
                PMUmsg = t('result_france_outbound_PMU').replace('{0}', t('oddsType_' + PMUPool[0]));
            }
        }

        return (
            <AllResultWrapper id="results_all_result_pc">
                {raceNosData?.map((raceNo, idx) => (
                    renderResultCard(raceNo)
                ))}
                {/* {PMUmsg === '' ? <></> : <StyledRemarkDiv><p>{PMUmsg}</p></StyledRemarkDiv>} */}
                {["START", 'DECLARED', 'DEFINED', 'DRAFT'].includes(meetingStatus.toUpperCase()) ? <></> : <SimulcastRemark />}
                    
                {PMUmsg !== '' ? <StyledRemarkDiv>
                    <p id={"Result_PMUNote"} dangerouslySetInnerHTML={{ __html: t('result_france_outbound_PMU_Note') }} />
                </StyledRemarkDiv> : null}
            </AllResultWrapper>
        )
    }

    const getResultVideo = (raceNo: number) => resultVideos?.find((v: VideoReplay) => v.raceNo === paddingNum(raceNo))

    const resultVideo = getResultVideo(selectedRaceNo)

    const fullFieldPlacing = raceDesc?.fullResultReady;

    // if (myContextState?.dataSource === 'qids' && isLoadingPage) return <Loading source="Results"/>
    if (myContextState?.dataSource !== 'qids' && !hasResultsData)
        return (<NoInformation />)
    
    const customContent = 
        myContextState?.dataSource === 'qids' 
        && (isLoadingPage 
            ? <Loading/> 
            : (!hasResultsData && <NoInformation />))
    
    return (
        <>
            { myContextState.dataSource === "qids" && typeof raceSelectorData === 'object' && Object.values(raceSelectorData).length &&<RaceSelector
                type={props?.type || 'pc'}
                enableAllBtn={props?.type === 'pc'}
                selectedVenueCode={selectedVenueCode}
                selectedRaceNo={selectedRaceNo}
                handleSelectRace={handleSelectRace}
                data={raceSelectorData}
            ></RaceSelector> }
        { customContent ? customContent :
            (props?.type === "pc" ? (
                        <ResultPageWrapper>
                            {selectedRaceNo == -1 ? renderAllResult() :
                                <>
                                    <Grid container id="resultTopInfoWrapper">
                                        <Grid lg={10.5} container justifyContent="start" columnSpacing={3} item id="resultBasicInfo" >
                                            <Grid item>
                                                <Grid id={`results_race_name_${selectedRaceNo}_pc`}>{raceDesc?.raceName}</Grid>
                                                <Grid id={`results_time_${selectedRaceNo}_pc`}>{raceDesc?.time}</Grid>
                                            </Grid>
                                            <Grid item>
                                                <Grid id={`results_going_${selectedRaceNo}_pc`}>{t('result_going')}: {raceDesc?.going}</Grid>
                                                <Grid id={`results_course_${selectedRaceNo}_pc`}>{t('result_course')}: {raceDesc?.course}</Grid>
                                            </Grid>
                                            <Grid item>
                                                {fullFieldPlacing && raceDesc?.winningTime !== '' ? <Grid>{t('result_winning_time')}: {raceDesc?.winningTime}</Grid> : <Grid></Grid>}
                                            </Grid>
                                        </Grid>
                                        {
                                            isDisplayReplay && resultVideo?.showVideoIcon() &&
                                            <Grid lg={1.5} container item id="resultRaceReplay" className="resultRaceReplay" justifyContent="center">
                                                <span onClick={() => openVideoPlayer(myContextState.selectedRaceNo.valueOf(), resultVideo)}>{t('result_race_replay')}</span>
                                                <ReplayIcon onClick={() => openVideoPlayer(myContextState.selectedRaceNo.valueOf(), resultVideo)} />
                                            </Grid>
                                        }
                                    </Grid>
                                    {
                                        displayMessage !== '' ? (displayMessage === 'result_not_offered' ? <DivNotOfferMessage>{t(displayMessage)}</DivNotOfferMessage> : <DivMessage>{t(displayMessage)}</DivMessage>) : <></>
                                    }
                                    {
                                        isShowResult && <ResultTable type="pc" raceNo={selectedRaceNo} data={raceData} fullFieldPlacing={fullFieldPlacing} columns={!fullFieldPlacing ? ["place", "horseNo", "horse", "jockey"] : undefined} disableExpansion={!fullFieldPlacing}></ResultTable>
                                    }
                                    {
                                        isShowDividend ? <DividendTable type="pc" hasResult={isShowResult} isFullWidth showDivNote data={pmPoolsData} raceNo={selectedRaceNo}></DividendTable> : (isShowResult || displayMessage.indexOf('_abandoned') > 0 || displayMessage.indexOf('_void') > 0) && <SimulcastRemarkNonWagering />
                                    }
                                </>
                            }
                        </ResultPageWrapper>
            ) : (
                    <>
                        <Grid container id="resultTopInfoWrapper" className="mobile">
                            {
                                lang.langCode == "en-us" ? <>
                                <Grid xs={isDisplayReplay && resultVideo?.showVideoIcon() ? 8.5 : 12} container item id="resultBasicInfo" > 
                                    <Grid id={`results_race_time_${selectedRaceNo}_mobile`} xs={12} item>{raceDesc?.time}</Grid>
                                    <Grid id={`results_race_name_${selectedRaceNo}_mobile`} xs={12} item>{raceDesc?.raceName}</Grid>
                                    <Grid id={`results_race_course_${selectedRaceNo}_mobile`} xs={12} item>{raceDesc?.course}</Grid>
                                    {(raceDesc?.going || '-') === '-' ? <></> : <Grid xs={12} item>{raceDesc?.going}</Grid>}
                                    {fullFieldPlacing && raceDesc?.winningTime !== '' ? <Grid xs={12} item>{t('result_winning_time')}: {raceDesc?.winningTime}</Grid> : <Grid xs={12} item></Grid>}
                                </Grid>
                                {
                                isDisplayReplay && resultVideo?.showVideoIcon() &&
                                <Grid xs={3.5} item id="resultRaceReplay" className="resultRaceReplay mobile">
                                    <span onClick={() => openVideoPlayer(myContextState.selectedRaceNo.valueOf(), resultVideo)}>{t('result_race_replay')}</span>
                                    <ReplayIcon onClick={() => openVideoPlayer(myContextState.selectedRaceNo.valueOf(), resultVideo)} />
                                </Grid>
                                }  
                                </> : <>
                                <Grid  
                                container item id="resultBasicInfo" 
                                style={{width: isDisplayReplay && resultVideo?.showVideoIcon() ? "calc(100% - 118px)" : "100%"}} > 
                                <Grid id={`results_race_time_${selectedRaceNo}_mobile`} xs={12} item>{raceDesc?.time}</Grid>
                                <Grid id={`results_race_name_${selectedRaceNo}_mobile`} xs={12} item>{raceDesc?.raceName}</Grid>
                                <Grid id={`results_race_course_${selectedRaceNo}_mobile`} xs={12} item>{raceDesc?.course}</Grid>
                                {(raceDesc?.going || '-') === '-' ? <></> : <Grid xs={12} item>{raceDesc?.going}</Grid>}
                                {fullFieldPlacing && raceDesc?.winningTime !== '' ? <Grid xs={12} item>{t('result_winning_time')}: {raceDesc?.winningTime}</Grid> : <Grid xs={12} item></Grid>}
                                </Grid>
                                {
                                isDisplayReplay && resultVideo?.showVideoIcon() &&
                                <Grid item id="resultRaceReplay" className="resultRaceReplay mobile" style={{width: "118px"}}>
                                    <span onClick={() => openVideoPlayer(myContextState.selectedRaceNo.valueOf(), resultVideo)}>{t('result_race_replay')}</span>
                                    <ReplayIcon onClick={() => openVideoPlayer(myContextState.selectedRaceNo.valueOf(), resultVideo)} />
                                </Grid>
                                }
                                </>
                            }
                            
                        </Grid>
                        {
                            displayMessage !== '' ? (displayMessage === 'result_not_offered' ? <DivNotOfferMessage>{t(displayMessage)}</DivNotOfferMessage> : <DivMessage>{t(displayMessage)}</DivMessage>) : <></>
                        }
                        <MResultWrapper>
                            <Grid id={`results_table_${selectedRaceNo}_mobile`} className="mobile">
                                {
                                    isShowResult && <ResultTable type="mobile" raceNo={selectedRaceNo} fullFieldPlacing={fullFieldPlacing} data={raceData} columns={!fullFieldPlacing ? ["place", "horseNo", "horse", "jockey"] : undefined} disableExpansion={!fullFieldPlacing}></ResultTable>
                                }
                            </Grid>
                            {
                                isShowDividend ? <DividendTable type="mobile" hasResult={isShowResult} showDivNote data={pmPoolsData} raceNo={selectedRaceNo}></DividendTable> : (isShowResult || displayMessage.indexOf('_abandoned') > 0 || displayMessage.indexOf('_void') > 0) && <SimulcastRemarkNonWagering />
                            }
                        </MResultWrapper>
                    </>
            ))
        }
            <VideoPlayer overridedContentSlot={overridedContentSlot} WAData={WAData} title={t("race_replay_title")} sources={replaySources} open={isShowReplay} isMobile={isMobile} handleClose={handleClose} width={isMobile?undefined:'60%'} height={isMobile?undefined:'60%'} showCurrentTooltip showHoveredTooltip autoPlay />
        </>
    )
}

export default Results; 